import React, {ReactElement} from 'react'
import {Lang} from 'yougile-lang'
import {Tag} from 'yougile-model'
import {Dialog} from '@components/common/base/dialog/dialog'
import {MessageBox} from '@components/message-box'
import {getAllBoards} from '@components/sticker/my-stickers/my-stickers-utils'
import {PageService} from '@extensions/page-service'
import {Sticker} from '@extensions/sticker/sticker'

export const RemoveStickerPopup = ({
  sticker,
  close,
  removeFrom = 'board'
}: {
  sticker: Tag
  close: () => void
  removeFrom?: 'board' | 'system'
}): ReactElement => {
  const removeClick = (): void => {
    if (removeFrom === 'board') {
      const board = PageService.getCurrentBoard()
      Sticker.removeFromBoard(board, sticker)
    } else if (removeFrom === 'system') {
      const allBoards = getAllBoards()
      for (const board of allBoards) {
        if (Sticker.isInBoardOrSettings(board, sticker)) {
          Sticker.removeFromBoard(board, sticker)
        }
      }
    }

    sticker.deleted = true
    sticker.commit()

    MessageBox.show(Lang.msg.myStickers.settingsApplied, 'success', {
      modern: true
    })
    close()
  }

  let subtitle = ''

  if (removeFrom === 'board') {
    subtitle = Lang.msg.myStickers.removeStickerFromBoardContent
  }

  if (removeFrom === 'system') {
    subtitle = Lang.msg.myStickers.removeStickerFromSystemContent
  }

  return (
    <Dialog
      close={close}
      isDelete
      title={Lang.msg.myStickers.removeStickerTitle}
      subtitle={subtitle}
      submit={removeClick}
      primaryBtnText={Lang.msg.delete}
    />
  )
}
